/* SIDONIA · Favoritos: corazón de la tarjeta, contador de la cabecera y página de favoritos.
   La lista se guarda solo en este navegador (localStorage), sin cuenta ni datos personales. */
(() => {
  if (window.customElements.get('sidonia-fav')) return;

  /* «Vende con nosotros»: si tras enviar el formulario Shopify vuelve a la página sin ?view=vender (porque la página
     tiene otra plantilla asignada), se recarga con la plantilla del formulario para ver el «¡Recibido!». */
  try {
    const params = new URLSearchParams(location.search);
    if (params.get('contact_posted') === 'true' && !params.has('view') && sessionStorage.getItem('sidonia:vender-tipo') !== null
      && !document.querySelector('[data-sell-done]')) {
      params.set('view', 'vender');
      location.replace(`${location.pathname}?${params.toString()}${location.hash}`);
    }
  } catch (e) { /* sin sessionStorage: no pasa nada */ }

  const KEY = 'sidonia:favoritos';
  const EVENT = 'sidonia:favoritos';
  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
    } catch (e) {
      return [];
    }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* navegación privada */ }
    document.dispatchEvent(new CustomEvent(EVENT));
  };
  // Otra pestaña ha cambiado la lista
  window.addEventListener('storage', (event) => {
    if (event.key === KEY) document.dispatchEvent(new CustomEvent(EVENT));
  });

  /* Corazón de cada tarjeta */
  class SidoniaFav extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.handle = this.getAttribute('handle');
      this.onChange = () => this.sync();
      document.addEventListener(EVENT, this.onChange);
      this.sync();
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const list = read();
        const i = list.indexOf(this.handle);
        if (i === -1) list.unshift(this.handle); else list.splice(i, 1);
        write(list);
        // Para las estadísticas (snippets/sidonia-estadisticas.liquid)
        document.dispatchEvent(new CustomEvent('sidonia:like', { detail: { handle: this.handle, on: i === -1 } }));
      });
    }

    disconnectedCallback() {
      document.removeEventListener(EVENT, this.onChange);
    }

    sync() {
      this.button.setAttribute('aria-pressed', String(read().includes(this.handle)));
    }
  }

  /* Contador de la cabecera */
  class SidoniaFavCount extends HTMLElement {
    connectedCallback() {
      this.onChange = () => this.sync();
      document.addEventListener(EVENT, this.onChange);
      this.sync();
      if (this.centro) requestAnimationFrame(() => requestAnimationFrame(() => this.escala()));
    }

    disconnectedCallback() {
      document.removeEventListener(EVENT, this.onChange);
    }

    sync() {
      const n = read().length;
      this.textContent = n > 0 ? String(n) : '';
      this.classList.toggle('opacity-0', n === 0);
      const link = this.closest('a');
      const label = link && link.querySelector('.sr-only');
      if (label) label.textContent = n > 0 ? `Favoritos (${n})` : 'Favoritos';
    }
  }

  /* Panel de favoritos (snippets/sidonia-favorites-drawer.liquid): pide cada tarjeta a /products/<handle>?view=sidonia-card */
  class SidoniaFavList extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-fav-grid]');
      this.empty = this.querySelector('[data-fav-empty]');
      this.status = this.querySelector('[data-fav-status]');
      this.loading = this.querySelector('[data-fav-loading]');
      this.onChange = () => this.prune();
      document.addEventListener(EVENT, this.onChange);
    }

    disconnectedCallback() {
      document.removeEventListener(EVENT, this.onChange);
    }

    async load() {
      const run = (this.run || 0) + 1;
      this.run = run;
      const handles = read();
      this.setAttribute('aria-busy', 'true');
      if (this.loading) this.loading.hidden = handles.length === 0;
      if (handles.length === 0) this.grid.innerHTML = '';

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cards = await Promise.all(handles.map(async (handle) => {
        try {
          const res = await fetch(`${root}products/${encodeURIComponent(handle)}?view=sidonia-card`, { credentials: 'same-origin' });
          if (!res.ok) return { handle, gone: res.status === 404 };
          const html = (await res.text()).trim();
          return html.includes('sidonia-card') ? { handle, html } : { handle };
        } catch (e) {
          return { handle };
        }
      }));
      if (run !== this.run) return; // se volvió a abrir mientras cargaba

      // Productos borrados de la tienda: se quitan de la lista
      const gone = cards.filter((c) => c.gone).map((c) => c.handle);
      if (gone.length) write(read().filter((h) => !gone.includes(h)));

      this.grid.innerHTML = '';
      cards.filter((c) => c.html).forEach((c) => {
        const item = document.createElement('li');
        item.className = 'sidonia-favs-drawer__item';
        item.dataset.handle = c.handle;
        item.innerHTML = c.html;
        this.grid.appendChild(item);
      });
      if (this.loading) this.loading.hidden = true;
      this.setAttribute('aria-busy', 'false');
      this.loaded = true;
      this.update();
    }

    prune() {
      if (!this.loaded) return;
      const list = read();
      this.grid.querySelectorAll('[data-handle]').forEach((item) => {
        if (!list.includes(item.dataset.handle)) item.remove();
      });
      this.update();
    }

    update() {
      const n = this.grid.children.length;
      this.empty.hidden = n > 0;
      this.grid.hidden = n === 0;
      if (this.status) this.status.textContent = n > 0 ? `(${n})` : '';
    }
  }

  /* Abrir y cerrar el panel */
  const drawer = () => document.getElementById('sidonia-favs-drawer');
  const closeDrawer = () => {
    const d = drawer();
    if (d && d.open) d.close();
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-sidonia-favs-open]');
    if (opener) {
      const d = drawer();
      if (!d || typeof d.showModal !== 'function') return;
      event.preventDefault();
      if (!d.open) d.showModal();
      const list = d.querySelector('sidonia-fav-list');
      if (list && list.load) list.load();
      return;
    }
    if (event.target.closest('[data-sidonia-favs-close]')) {
      closeDrawer();
      return;
    }
    // Clic fuera del panel (en el fondo oscuro)
    const d = drawer();
    if (d && d.open && event.target === d) closeDrawer();
  });

  /* Fila deslizable: flechas «anteriores/siguientes» (botones con aria-controls = id de la pista).
     Con data-loop en la pista, la fila no se acaba: se copian tarjetas a los dos lados (a la izquierda las últimas, a la derecha las primeras) y, al parar de deslizar,
     se salta sin que se note a la misma tarjeta del bloque del centro (se puede deslizar a la izquierda y a la derecha). */
  class SidoniaScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track || !this.track.id) return;
      this.loop = this.track.hasAttribute('data-loop') && this.setupLoop();
      this.buttons = [...document.querySelectorAll(`[aria-controls="${this.track.id}"][data-scroll]`)];
      this.buttons.forEach((button) => button.addEventListener('click', () => {
        const dir = button.dataset.scroll === 'prev' ? -1 : 1;
        const card = this.track.firstElementChild;
        const step = this.loop && card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth * 0.9;
        this.track.scrollBy({ left: dir * step });
      }));
      // data-centro (móvil): el anuncio del centro a tamaño normal y los de los lados un poco más pequeños y apagados
      this.movil = window.matchMedia('(max-width: 699px)');
      this.centro = this.track.hasAttribute('data-centro');
      this.onScroll = () => {
        this.sync();
        if (this.centro) { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.escala()); }
        if (!this.loop) return;
        clearTimeout(this.settle);
        this.settle = setTimeout(() => this.wrap(), 140);
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.sync();
      if (this.centro) requestAnimationFrame(() => requestAnimationFrame(() => this.escala()));
    }

    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('resize', this.onScroll);
    }

    setupLoop() {
      let items = [...this.track.children];
      if (items.length < 3) return false;
      // data-mezclar: las 12 primeras (las más nuevas) en su orden y el resto al azar, para que al deslizar a la
      // izquierda no salgan los más antiguos
      if (this.track.hasAttribute('data-mezclar') && items.length > 13) {
        const resto = items.slice(12);
        for (let i = resto.length - 1; i > 0; i -= 1) { const j = Math.floor(Math.random() * (i + 1)); [resto[i], resto[j]] = [resto[j], resto[i]]; }
        this.track.append(...resto);
        items = [...this.track.children];
      }
      // data-loop-sobra: solo sin fin si no caben todas en pantalla (si caben, no se repiten)
      if (this.track.hasAttribute('data-loop-sobra') && this.track.scrollWidth <= this.track.clientWidth + 2) return false;
      const copia = (el) => {
        const c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.dataset.clone = '';
        c.querySelectorAll('a, button, [tabindex]').forEach((x) => x.setAttribute('tabindex', '-1'));
        return c;
      };
      // Con muchas (todas las de la tienda) no se copian todas: solo las últimas a la izquierda y las primeras a la
      // derecha, las justas para que no se note el salto
      // offsetLeft de las tarjetas, medido desde la pista
      if (getComputedStyle(this.track).position === 'static') this.track.style.position = 'relative';
      const n = Math.min(items.length, 10);
      this.track.prepend(...items.slice(-n).map(copia));
      this.track.append(...items.slice(0, n).map(copia));
      this.first = items[0];
      this.after = this.track.children[n + items.length];
      // Empieza con la primera tarjeta de verdad alineada con el título (el margen de la fila); a su izquierda asoma la
      // anterior, como a la derecha asoma la siguiente
      this.pad = () => parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      requestAnimationFrame(() => this.jumpTo(this.first.offsetLeft - this.pad()));
      return true;
    }

    escala() {
      const hijos = [...this.track.children];
      if (!this.movil.matches) { if (this.escalado) { hijos.forEach((c) => { c.style.transform = ''; c.style.opacity = ''; }); this.escalado = false; } return; }
      this.escalado = true;
      const medio = this.track.scrollLeft + this.track.clientWidth / 2;
      hijos.forEach((c) => {
        const d = Math.min(Math.abs(c.offsetLeft + c.offsetWidth / 2 - medio) / (c.offsetWidth || 1), 1);
        c.style.transform = d ? `scale(${(1 - d * 0.08).toFixed(3)})` : '';
        c.style.opacity = d ? (1 - d * 0.35).toFixed(3) : '';
      });
    }

    jumpTo(left) {
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = left;
      this.track.style.scrollBehavior = '';
    }

    wrap() {
      const set = this.after.offsetLeft - this.first.offsetLeft;
      if (!set) return;
      const x = this.track.scrollLeft;
      const inicio = this.first.offsetLeft - this.pad();
      if (x < inicio - 2) this.jumpTo(x + set);
      else if (x >= inicio + set) this.jumpTo(x - set);
    }

    sync() {
      if (this.loop) { this.buttons.forEach((button) => { button.disabled = false; }); return; }
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.buttons.forEach((button) => {
        const atEdge = button.dataset.scroll === 'prev' ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max;
        button.disabled = atEdge;
      });
    }
  }

  window.customElements.define('sidonia-fav', SidoniaFav);
  window.customElements.define('sidonia-fav-count', SidoniaFavCount);
  window.customElements.define('sidonia-fav-list', SidoniaFavList);
  window.customElements.define('sidonia-scroller', SidoniaScroller);
})();
